module.exports = __webpack_public_path__ + "img/b2.af26a298.png";